import React, { useState, useEffect } from 'react'
import './styles.scss'
import DeleteIcon from '../../assets/bin.svg'
import { Icon } from 'antd'
import { useSelector } from 'react-redux'

const TYPES = {
  ICON: 'Icon',
  SIGNATURE: 'Signature',
  SIGNATURE_TWO: 'SignatureTwo',
  LOGO: 'Logo',
  LOGO_TWO: 'LogoTwo',
  CERTIFICATE: 'Cert'
}

const Template = props => {
  const user = useSelector(state => state.user)
  const orgName = user?.info?.organization?.title || 'XYZ Organization'

  const TEXT = {
    line1: 'CERTIFICATE',
    line2: 'OF ACHIEVEMENT',
    line3: 'THIS CERTIFICATE IS PRESENTED TO :',
    line4: 'Name Here',
    line5: `The certificate is issued by the ${orgName} on the basis that the awardee has completed a program of intensive learning that endows them with a fundamental understanding of education. The awardee has the rudimentary knowledge needed to engage in educational activities on a professionally informed basis in the workplace`,
    line6: 'Name Here',
    line7: 'CEO, XYZ Organization',
    line8: 'Name of Person',
    line9: 'Post'
  }

  const [state, setState] = useState({
    line1: TEXT.line1,
    line2: TEXT.line2,
    line3: TEXT.line3,
    line4: TEXT.line4,
    line5: TEXT.line5,
    line6: TEXT.line6,
    line7: TEXT.line7,
    line8: TEXT.line8,
    line9: TEXT.line9,
    template: null
  })

  const handleText = e => {
    const { onText } = props
    const name = e.target.name
    const value = e.target.value
    setState(prevState => ({
      ...prevState,
      [name]: value
    }))

    if (onText) {
      onText({
        name: name,
        value: value
      })
    }
  }

  const putTextInCanvas = () => {
    const {
      certificateHistory,
      userName,
      userView,
      clearCertificate,
      onClear
    } = props

    if (clearCertificate) {
      setState(prevState => ({
        ...prevState,
        line1: TEXT.line1,
        line2: TEXT.line2,
        line3: TEXT.line3,
        line5: TEXT.line5,
        line6: TEXT.line6,
        line7: TEXT.line7,
        line8: TEXT.line8,
        line9: TEXT.line9
      }))
      if (onClear) onClear()
    } else if (certificateHistory) {
      setState(prevState => ({
        ...prevState,
        line1: certificateHistory.line1 || TEXT.line1,
        line2: certificateHistory.line2 || TEXT.line2,
        line3: certificateHistory.line3 || TEXT.line3,
        line5: certificateHistory.line5 || TEXT.line5,
        line6: certificateHistory.line6 || TEXT.line6,
        line7: certificateHistory.line7 || TEXT.line7,
        line8: certificateHistory.line8 || TEXT.line8,
        line9: certificateHistory.line9 || TEXT.line9
      }))
    }

    if (userView) {
      setState(prevState => ({
        ...prevState,
        line4: userName,
        template: certificateHistory
          ? certificateHistory.selectedTemplate
          : null
      }))
    }
  }

  useEffect(() => {
    const { userView } = props
    if (userView) {
      putTextInCanvas()
    }
  }, [])

  useEffect(() => {
    putTextInCanvas()
  }, [props])

  const clearImage = type => {
    const { onClearImage } = props
    return (
      <div
        className="certificate_clear_image"
        onClick={() => onClearImage && onClearImage(type)}
      >
        <img alt="" src={DeleteIcon} />
      </div>
    )
  }

  const {
    icon,
    userIcon,
    signaturesById,
    userView,
    template,
    addSignature,
    iconById,
    logoById,
    isFetching,
    logosById = []
  } = props

  const certificateIcon = icon || userIcon

  if (isFetching) {
    return (
      <div className="certificate-loading">
        <p>
          Generating Certificate... <Icon type="loading" />
        </p>
      </div>
    )
  }

  return (
    <div
      className="certificate-template"
      style={{
        backgroundImage: `url(${userView ? state.template : template})`,
        pointerEvents: userView ? 'none' : 'all'
      }}
    >
      <div className="certificate-content">
        {/* Certificate Badge/Icon */}
        <div className="certificate-badge">
          {!certificateIcon && (
            <div style={{ height: '80px', width: '80px' }} />
          )}
          {certificateIcon && !userView && (
            <img
              alt=""
              src={certificateIcon === userIcon ? iconById : certificateIcon}
              style={{
                height: '80px',
                width: '80px',
                objectFit: 'contain'
              }}
            />
          )}
          {certificateIcon && userView && (
            <img
              alt=""
              crossOrigin="anonymous"
              src={certificateIcon === userIcon ? iconById : certificateIcon}
              style={{
                height: '80px',
                width: '80px',
                objectFit: 'contain'
              }}
            />
          )}
          {certificateIcon && clearImage(TYPES.ICON)}
        </div>

        {/* Main Certificate Content */}
        {/* Title */}
        <div className="certificate-title">
          <input
            type="text"
            name="line1"
            onChange={handleText}
            value={state.line1}
            className="title-input"
          />
        </div>

        {/* Subtitle */}
        <div className="certificate-subtitle">
          <input
            type="text"
            name="line2"
            onChange={handleText}
            value={state.line2}
            className="subtitle-input"
          />
        </div>

        {/* Presented To Text */}
        <div className="certificate-presented">
          <input
            type="text"
            name="line3"
            onChange={handleText}
            value={state.line3}
            className="presented-input"
          />
        </div>

        {/* Name */}
        <div className="certificate-name">
          <input
            type="text"
            name="line4"
            onChange={handleText}
            value={state.line4}
            className="name-input"
            disabled
          />
        </div>

        {/* Description */}
        <div className="certificate-description">
          <textarea
            maxLength="500"
            spellCheck="false"
            onChange={handleText}
            value={state.line5}
            name="line5"
            className="description-input"
          />
        </div>

        {/* Signature Section */}
        <div className="certificate-signature">
          {/* Additional Signature - Bottom Right (if enabled) */}
          {addSignature && (
            <div className="certificate-signature-right">
              <div className="signature-img">
                {!signaturesById[1] && (
                  <div style={{ height: '30px', width: '60px' }} />
                )}
                {signaturesById && signaturesById[1] && !userView && (
                  <img
                    alt=""
                    src={signaturesById[1].link}
                    style={{
                      height: '30px',
                      width: '60px',
                      objectFit: 'contain'
                    }}
                  />
                )}
                {signaturesById && signaturesById[1] && userView && (
                  <img
                    alt=""
                    crossOrigin="anonymous"
                    src={signaturesById[1].link}
                    style={{
                      height: '30px',
                      width: '60px',
                      objectFit: 'contain'
                    }}
                  />
                )}
                {signaturesById &&
                  signaturesById[1] &&
                  clearImage(TYPES.SIGNATURE_TWO)}
              </div>
              <div className="signature_name">
                <input
                  type="text"
                  name="line8"
                  onChange={handleText}
                  value={state.line8}
                />
              </div>
              <div className="signature_sub">
                <input
                  type="text"
                  name="line9"
                  onChange={handleText}
                  value={state.line9}
                />
              </div>
            </div>
          )}
          {/* Main Signature Image */}
          {signaturesById && signaturesById[0] && (
            <div className="certificate-main-signature">
              {!userView && (
                <img
                  alt=""
                  src={signaturesById[0].link}
                  style={{
                    height: '45px',
                    width: '135px',
                    objectFit: 'contain'
                  }}
                />
              )}
              {userView && (
                <img
                  alt=""
                  crossOrigin="anonymous"
                  src={signaturesById[0].link}
                  style={{
                    height: '45px',
                    width: '135px',
                    objectFit: 'contain'
                  }}
                />
              )}
              {clearImage(TYPES.SIGNATURE)}
            </div>
          )}
          <div className="signature-line"></div>
          <div className="signature-name">
            <input
              type="text"
              name="line6"
              rows={4}
              onChange={handleText}
              value={state.line6}
              className="signature-name-input"
            />
          </div>
          <div className="signature-title">
            <input
              type="text"
              name="line7"
              onChange={handleText}
              value={state.line7}
              className="signature-title-input"
            />
          </div>
        </div>
      </div>

      {/* Logo Section - Bottom Left */}
      <div className="certificate-logo-left">
        {!logosById[0] && <div style={{ height: '40px', width: '60px' }} />}
        {logosById[0] && !userView && (
          <img
            alt=""
            src={logosById[0] && logosById[0].link}
            style={{ height: '40px', width: 'auto' }}
          />
        )}
        {logosById[0] && userView && (
          <img
            alt=""
            src={logosById[0] && logosById[0].link}
            crossOrigin="anonymous"
            style={{ height: '40px', width: 'auto' }}
          />
        )}
        {logosById[0] && clearImage(TYPES.LOGO)}
      </div>

      {/* Logo Section - Bottom Right */}
      <div className="certificate-logo-right">
        {logosById[1] && !userView && (
          <img
            alt=""
            src={logosById[1] && logosById[1].link}
            style={{ height: '40px', width: 'auto' }}
          />
        )}
        {logosById[1] && userView && (
          <img
            alt=""
            src={logosById[1] && logosById[1].link}
            crossOrigin="anonymous"
            style={{ height: '40px', width: 'auto' }}
          />
        )}
        {logosById[1] && clearImage(TYPES.LOGO_TWO)}
      </div>
    </div>
  )
}

export default Template
